import { requireManageBadgesOrgPermission } from '../../../../../backend/features/badges/shared';
import { filterBadgeOrganizationIdsUserHasPermissions } from '../../../../../backend/features/badges/shared/utils/filterBadgeOrganizationIdsUserHasPermissions';
import { useBadgeActions } from '../../../../../ui/features/badge-management/hooks/useBadgeActions';
import { useBadgingTranslation } from '../../../../../ui/hooks';
import { visuallyHidden } from '@juvare/common-form-ui/utils/visualyHidden';
import { MenuIconButton } from '@juvare/common-web-ui/MenuIconButton';
import { requireAnyOrgPermission, requireAnySystemPermission } from '@juvare/contact-management/backend/features/permissions/shared';
import { useUserState } from '@juvare/contact-management/ui/hooks';
import ChevronRightIconOutlined from '@mui/icons-material/ChevronRightOutlined';
import MoreHorizIconOutlined from '@mui/icons-material/MoreHorizOutlined';
import { Box, Divider, IconButton } from '@mui/material';
import React from 'react';
export const BadgeListItemActions = ({ badge, fetchBadgeList }) => {
    const { t } = useBadgingTranslation();
    const userState = useUserState();
    const { handleBadgeDetailsEdit, handleBadgeOrganizationsEdit, handleBadgeClick, handleBadgeDuplicateClick } = useBadgeActions({
        badge,
        onSuccess: fetchBadgeList,
    });
    const hasPermissionToEdit = requireAnySystemPermission(userState, 'manage-badges') ||
        requireManageBadgesOrgPermission(userState, filterBadgeOrganizationIdsUserHasPermissions(userState, badge.organizationIds).badgeOrgIdsCanManageAny);
    const canManageOrganizationMembers = requireAnySystemPermission(userState, 'all-organizations-admin') || requireAnyOrgPermission(userState, 'manage-members');
    const moreButtonMenuItems = [
        {
            label: t('common.duplicate'),
            onClick: handleBadgeDuplicateClick,
        },
        {
            label: t('common.editInformation'),
            onClick: handleBadgeDetailsEdit,
        },
    ];
    if (canManageOrganizationMembers) {
        moreButtonMenuItems.push({
            label: t('common.assignOrganization'),
            onClick: handleBadgeOrganizationsEdit,
        });
    }
    const ariaLabelId = React.useId();
    return (React.createElement(Box, { sx: { display: 'flex', gap: 2, width: { xs: '100%', sm: 'auto', flexShrink: 0 } } },
        hasPermissionToEdit && (React.createElement(React.Fragment, null,
            React.createElement(MenuIconButton, { color: 'primary', size: 'small', menuItems: moreButtonMenuItems, "data-test": 'more-actions-button', anchor: 'right', sx: {
                    ml: { xs: 'auto', sm: 0 },
                } },
                React.createElement(Box, { id: ariaLabelId, sx: visuallyHidden }, t('ariaLabels.moreActions')),
                React.createElement(MoreHorizIconOutlined, null)),
            React.createElement(Divider, { orientation: 'vertical', variant: 'middle', flexItem: true }))),
        React.createElement(IconButton, { color: 'primary', size: 'small', onClick: handleBadgeClick },
            React.createElement(ChevronRightIconOutlined, null))));
};
